import { Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useState } from 'react'
import * as bie from "react-bootstrap";
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import { PiBuildingOfficeDuotone } from "react-icons/pi";
import { AiOutlineFileDone } from "react-icons/ai";
import { FaMoneyCheck } from "react-icons/fa6";
import { IoMdEye } from "react-icons/io";

import Select from "react-select";
import { formatIndianNumber } from '../../CommonUtils/CommonValidations';
import { viewImage } from '../../CommonUtils/viewImage';


export default function CollegeWiseRusaReport(props) {


    const SchemeFormik = useFormik({
        initialValues: {
            clgname: "",
            progress: "",
        },
        enableReinitialize: true,
        // validationSchema: SchemeWiseComponentvalidation,

        onSubmit: (val) => {

        },

    })
    const { ClgList } = props;

    const [questionnaire, setQuestionnaire] = useState([]);
    const [reportdata, setreportdata] = useState([]);
    const [InstDeatils, setinstdetails] = useState([]);
    const [Errormsg, seterrormsg] = useState(null);
    const [Amountdata, setamountdata] = useState([]);


    function ReportDetails(collcode, progress) {

        if (
            collcode == null || collcode === "" ||
            progress == null || progress === ""
        ) {
            console.log("API not called – collcode or progress is empty / null / undefined");
            return;
        }
        let url = `${config.url.API_URL}getRusaUpdationReport?collCode=${collcode}&progress=${progress}`;

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {

                if (res?.data?.instDtls_status === true) {
                    setinstdetails(res?.data?.instDtls?.[0] || {});
                } else {
                    setinstdetails({});
                }
                if (res?.data?.AmountDetails_status === true) {
                    setamountdata(res?.data?.AmountDetails || [])
                }
                else {
                    setamountdata([]);
                }

                setreportdata(res?.data?.data || []);
                seterrormsg(true);

                if (res?.data?.quest_status === true && Array.isArray(res?.data?.quest)) {
                    setQuestionnaire(res.data.quest);
                } else {
                    setQuestionnaire([]);
                }

            } else {
                setreportdata([]);
                setQuestionnaire([]);
                seterrormsg(false);
            }
        });
    }
    const [NewInfradata, setNewInfradata] = useState([]);
    const [Rennovdata, setRennovdata] = useState([]);
    const [Eqipdata, setEqipdata] = useState([]);
    const [Softdata, setSoftdata] = useState([]);


    function GetSchemeInfraDeatils(clgcode, progress) {
        if (!clgcode || clgcode.trim() === "") return;

        let url = config.url.API_URL + "getSubCompWorksData?collCode=" + clgcode + "&progress=" + progress;


        CommonAxiosGet(url).then(res => {
            if (res?.data?.scode === "01") {
                setNewInfradata(Array.isArray(res?.data?.new) ? res.data.new : []);
                setRennovdata(Array.isArray(res?.data?.renov) ? res.data.renov : []);
                setEqipdata(Array.isArray(res?.data?.equi) ? res.data.equi : []);
                setSoftdata(Array.isArray(res?.data?.soft) ? res.data.soft : []);


            } else {
                setNewInfradata([]);
                setRennovdata([]);
                setEqipdata([]);
                setSoftdata([]);
            }
        });
    }

    const noDataFound =
        Errormsg === false &&
        NewInfradata?.length === 0 ||
        Rennovdata?.length === 0 ||
        Eqipdata?.length === 0 ||
        Softdata?.length === 0;

    const schemes = [
        ...new Set([
            ...(NewInfradata || []).map(i => i.scheme),
            ...(Rennovdata || []).map(i => i.scheme),
            ...(Eqipdata || []).map(i => i.scheme),
            ...(Softdata || []).map(i => i.scheme),
            ...(Array.isArray(Amountdata) ? Amountdata : []).map(a => a.rusa_phase),
        ])
    ].filter(Boolean);

    const collegeOptions =
        ClgList !== "No data found"
            ? [
                { value: "", label: "-- Select Institute --" },   // ✅ default option
                ...(ClgList?.map((univ) => ({
                    value: univ.aishe_code,
                    label: univ.inst_name,
                })) || [])
            ]
            : [{ value: "", label: "-- Select Institute --" }];

    const handleViewImage = (photoUrl) => {
        if (!photoUrl) return;

        viewImage(photoUrl);   // your existing function
    };




    const InfraTable = ({ title, data }) => {
        if (!data.length) return null;
        return (
            <div className="card shadow-sm pt-3 p-0 mb-4 border-0">
                {/* <h5 className="fw-bold mb-3 text-primary">{title}</h5> */}

                <div className="table-responsive">
                    <table className="table table-bordered table-hover align-middle mb-0">
                        <thead className="table-light text-center">
                            <tr>
                                <th>S.No</th>
                                {/* <th>Component</th> */}
                                {/* <th>Sub Component Name</th> */}
                                <th>Sub Component Work</th>
                                <th>Status</th>
                                <th>Start Date</th>
                                <th>Completion Date</th>
                                <th>{data[0]?.sub_comp_name === "Soft Components" ? "No.of participants- Faculty/Students/Others" : "Number of Units"}</th>

                                <th>{data[0]?.sub_comp_name === "Soft Components" ? "Conducted at" : " Percentage of Completion"}</th>

                                {/* <th> Percentage of Completion</th> */}
                                <th>Remaining Days Left</th>
                                <th>Photo</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    <td className="text-center">{index + 1}</td>
                                    {/* <td>{item?.comp_name}</td> */}
                                    {/* <td>{item.sub_comp_name}</td> */}
                                    <td>{item.sub_comp_name_works || "-"}</td>

                                    <td className="text-center">
                                        {item.sub_comp_name === "Soft Components"
                                            ? item.activity_status
                                            : item.progress_of_work}
                                    </td>

                                    <td className="text-center">
                                        {item.start_date
                                            ? new Date(item.start_date).toLocaleDateString("en-GB")
                                            : "-"}
                                    </td>

                                    <td className="text-center">
                                        {item.date_of_completion
                                            ? new Date(item.date_of_completion).toLocaleDateString("en-GB")
                                            : "-"}
                                    </td>

                                    <td className="text-center">
                                        {item.sub_comp_name !== "Soft Components"
                                            ? item.no_of_units_constructed
                                            : item?.no_of_participate || "-"}
                                    </td>




                                    <td className="text-center" style={{ minWidth: "120px" }}>
                                        {item.sub_comp_name !== "Soft Components" ? (
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <div style={{
                                                    width: "80px",
                                                    height: "10px",
                                                    backgroundColor: "#e0e0e0",
                                                    borderRadius: "5px",
                                                    overflow: "hidden"
                                                }}>
                                                    <div style={{
                                                        width: `${item.perc_of_completion}%`,
                                                        height: "100%",
                                                        backgroundColor: "#4caf50",
                                                        borderRadius: "5px"
                                                    }} />
                                                </div>
                                                <span>{item.perc_of_completion}%</span>
                                            </div>
                                        ) : (
                                            item?.conducted_at || "-"
                                        )}
                                    </td>

                                    <td style={{ minWidth: "260px" }}>
                                        {item.start_date && item.date_of_completion ? (() => {

                                            const start = new Date(item.start_date);
                                            const end = new Date(item.date_of_completion);
                                            const today = new Date();

                                            const totalDuration = end - start;
                                            const elapsed = today - start;
                                            const remainingTime = end - today;

                                            const progressPercent = Math.min(
                                                Math.max((elapsed / totalDuration) * 100, 0),
                                                100
                                            );

                                            const remainingDays = Math.max(
                                                Math.ceil(remainingTime / (1000 * 60 * 60 * 24)),
                                                0
                                            );

                                            let color;
                                            const remainingPercent = (remainingTime / totalDuration) * 100;

                                            if (remainingPercent <= 20) color = "#ff4d4d";
                                            else if (remainingPercent <= 50) color = "#ffcc00";
                                            else color = "#00b386";

                                            const endDateFormatted = end.toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                            });

                                            return (
                                                <div>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                        <span style={{ fontWeight: "700", fontSize: "1.4rem", color }}>
                                                            {remainingDays}
                                                        </span>

                                                        <span style={{ color: "#888" }}>Days Left</span>

                                                        <span>
                                                            <strong>Ends On :</strong> {endDateFormatted}
                                                        </span>
                                                    </div>

                                                    <div
                                                        style={{
                                                            height: "6px",
                                                            backgroundColor: "#ddd",
                                                            borderRadius: "5px",
                                                            marginTop: "5px",
                                                            overflow: "hidden",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: `${progressPercent}%`,
                                                                height: "100%",
                                                                backgroundColor: color,
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            );

                                        })() : "-"}
                                    </td>

                                    <td className="text-center">
                                        {item?.construction_photo ? (
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => handleViewImage(item.construction_photo)}
                                            >
                                                <IoMdEye size={30} />
                                            </button>
                                        ) : "-"}
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };
    const [selectedProgress, setSelectedProgress] = useState("");

    function filterByProgress(data) {
        if (!selectedProgress) return data;

        return data.filter((item) => {
            if (item?.sub_comp_name === "Soft Components") {
                return item?.activity_status?.toLowerCase() === selectedProgress.toLowerCase();
            }

            return item.progress_of_work?.toLowerCase() === selectedProgress.toLowerCase();
        });
    }


    return (

        <>
            <FormikProvider value={SchemeFormik}>
                <Form onChange={SchemeFormik?.handleChange} onSubmit={SchemeFormik.handleSubmit} className='affl-form'>
                    <bie.Row className="pt-4">
                        <bie.Col lg={3} xl={2}>
                            <label className="mb-1">Select Institution</label>
                        </bie.Col>
                        <bie.Col lg={3}>
                            <Select
                                options={collegeOptions}
                                placeholder="Search Institute..."
                                isSearchable
                                value={collegeOptions?.find(
                                    (opt) => opt.value === SchemeFormik?.values?.clgname
                                )}
                                onChange={(selected) => {
                                    SchemeFormik?.setFieldValue("clgname", selected?.value || "");
                                    SchemeFormik?.setFieldValue("progress", "");
                                    setNewInfradata([]);
                                    setinstdetails({});
                                    setQuestionnaire([]);
                                    setamountdata([])


                                }}
                                className="react-select-container"
                                classNamePrefix="react-select"
                            />
                        </bie.Col>

                        <bie.Col lg={3} xl={2}>
                            <label className="mb-1">Completed / Ongoing</label>
                        </bie.Col>
                        <bie.Col lg={3}>

                            <Field
                                as="select"
                                className="form-control form-control-md"
                                name="progress"

                                onChange={(e) => {
                                    const value = e.target.value;
                                    SchemeFormik.setFieldValue("progress", value);
                                    ReportDetails(SchemeFormik?.values?.clgname, value);
                                    // filterInfraByProgress(value);

                                    filterByProgress([]);
                                    setSelectedProgress(value) // 🔥 filter here
                                    GetSchemeInfraDeatils(SchemeFormik?.values?.clgname, value)

                                }}
                            >
                                <option value="">---select---</option>
                                <option value="completed">Completed</option>
                                <option value="ongoing">Ongoing</option>
                            </Field>
                        </bie.Col>




                    </bie.Row>
                    <bie.Container className="outer-page-content-container shadow-none px-0 px-md-3 m-0 mw-100 ">
                        {NewInfradata?.length > 0 ? (
                            <div className="container mt-4">

                                <div className="card shadow-sm p-4 mb-4">
                                    {/* <h4 className="fw-bold mb-3" style={{ color: "brown" }}>
                                        <PiBuildingOfficeDuotone size={30} /> Institute Profile
                                    </h4> */}
                                    <div className='overal-stathead'>
                                        <span><PiBuildingOfficeDuotone size={25} />  Institute Profile</span>
                                    </div>


                                    <div className="row g-3">
                                        <div className="col-md-4">
                                            {/* <span role="img" aria-label="institution" className="me-2">🏫</span> */}
                                            <strong className='d-block'>Institution: 🏫</strong> {InstDeatils?.inst_name}
                                        </div>

                                        <div className="col-md-4">
                                            {/* <span role="img" aria-label="code" className="me-2">🔢</span> */}
                                            <strong className='d-block'>AISHE Code : 🔢 </strong> {InstDeatils?.aishe_code}
                                        </div>

                                        <div className="col-md-4">
                                            {/* <span role="img" aria-label="district" className="me-2">📍</span> */}
                                            <strong className='d-block'>District: 📍</strong> {InstDeatils?.dist_name}
                                        </div>

                                        <div className="col-md-4">
                                            {/* <span role="img" aria-label="institution type" className="me-2">🏢</span> */}
                                            <strong className='d-block'>Type of Institution: 🏢</strong> {InstDeatils?.coll_nature_name}
                                        </div>

                                        <div className="col-md-4">
                                            {/* <span role="img" aria-label="principal" className="me-2">👨‍🏫</span> */}
                                            <strong className='d-block'>Principal Name: 👨‍🏫</strong> {InstDeatils?.principal_name}
                                        </div>

                                        <div className="col-md-4">
                                            {/* <span role="img" aria-label="mobile" className="me-2">📞</span> */}
                                            <strong className='d-block'> Principal Mobile: 📞</strong> {InstDeatils?.principal_mobile}
                                        </div>

                                        <div className="col-md-4">
                                            {/* <span role="img" aria-label="coordinator" className="me-2">🧑‍💼</span> */}
                                            <strong className='d-block'>Coordinator Name: 🧑‍💼</strong> {InstDeatils?.coordinator_name}
                                        </div>

                                        <div className="col-md-4">
                                            {/* <span role="img" aria-label="coordinator mobile" className="me-2">📱</span> */}
                                            <strong className='d-block'>Coordinator Mobile: 📱</strong> {InstDeatils?.coordinator_mobile}
                                        </div>

                                        <div className="col-md-4">
                                            {/* <span role="img" aria-label="email" className="me-2">✉️</span> */}
                                            <strong className='d-block'>Email: ✉️</strong> {InstDeatils?.coll_mail}
                                        </div>
                                    </div>


                                </div>


                                {schemes?.map((schemeName, index) => {

                                    const matchedAmount = Array.isArray(Amountdata)
                                        ? Amountdata.find(
                                            amt => amt?.rusa_phase?.trim() === schemeName?.trim()
                                        )
                                        : null;

                                    const filteredNew = filterByProgress(
                                        NewInfradata?.filter(item => item?.scheme === schemeName)
                                    );

                                    const filteredRenov = filterByProgress(
                                        Rennovdata?.filter(item => item?.scheme === schemeName)
                                    );

                                    const filteredEquip = filterByProgress(
                                        Eqipdata?.filter(item => item?.scheme === schemeName)
                                    );

                                    const filteredSoft = filterByProgress(
                                        Softdata?.filter(item => item?.scheme === schemeName)
                                    );

                                    // ❌ Skip empty schemes after filtering
                                    const hasData =
                                        filteredNew?.length ||
                                        filteredRenov?.length ||
                                        filteredEquip?.length ||
                                        filteredSoft?.length;

                                    if (!hasData) return null;
                                    const compName = filteredNew[0]?.comp_name || filteredRenov[0]?.comp_name || filteredEquip[0]?.comp_name || filteredSoft[0]?.comp_name;

                                    return (
                                        <div key={index} className="card shadow p-4 mb-5">

                                            {/* <h3 className="fw-bold mb-4" style={{ color: "brown" }}>
                                                <FaMoneyCheck size={35} /> {schemeName} Details
                                            </h3> */}
                                            <div className='overal-stathead'>
                                                <span className='fs-4'> {schemeName} Details</span>
                                            </div>

                                            {/* Amount Section */}
                                            <div className="row g-3 mb-4">
                                                <div className="col-md-4">
                                                    <strong>Amount Allocated: </strong>
                                                    {formatIndianNumber(matchedAmount?.amount_allocated)}
                                                </div>
                                                <div className="col-md-4">
                                                    <strong>Amount Utilised: </strong>
                                                    {formatIndianNumber(matchedAmount?.amount_utilised)}
                                                </div>
                                                <div className="col-md-4">
                                                    <strong>Balance Amount: </strong>
                                                    {formatIndianNumber(matchedAmount?.balance_amount)}
                                                </div>
                                            </div>
                                            <b className='mb-3' style={{ color: "rgba(255, 1, 1, 0.53)" }}>  Component Name : {compName}</b>


                                            {filteredNew?.length > 0 && (
                                                <>
                                                    <div className="d-flex align-items-center mb-0">

                                                        {/* <h5 className="fw-bold text-primary mb-0" style={{ flex: 1 }}>
                                                            🏗️ New Construction
                                                        </h5> */}
                                                        <div className='overal-stathead mb-0'>
                                                            <span className='fs-5'> 🏗️ New Construction</span>
                                                        </div>

                                                    </div>
                                                    <InfraTable title="" data={filteredNew} />
                                                </>
                                            )}

                                            {filteredRenov.length > 0 && (
                                                <>

                                                    {/* <h5 className="fw-bold text-primary mb-0" style={{ flex: 1 }}>
                                                        🛠️ Renovation / Upgradation
                                                    </h5> */}
                                                    <div className='overal-stathead mb-0'>
                                                        <span className='fs-5'> 🛠️ Renovation / Upgradation</span>
                                                    </div>

                                                    <InfraTable title="" data={filteredRenov} />
                                                </>
                                            )}

                                            {filteredEquip?.length > 0 && (
                                                <>

                                                    {/* <h5 className="fw-bold text-primary mb-0" style={{ flex: 1 }}>
                                                        💻 Equipment
                                                    </h5> */}
                                                    <div className='overal-stathead mb-0'>
                                                        <span className='fs-5'> 💻 Equipment</span>
                                                    </div>

                                                    <InfraTable title="" data={filteredEquip} />
                                                </>
                                            )}

                                            {filteredSoft?.length > 0 && (
                                                <>

                                                    {/* <h5 className="fw-bold text-primary mb-0" style={{ flex: 1 }}>
                                                        🎯 Soft Components
                                                    </h5> */}
                                                    <div className='overal-stathead mb-0'>
                                                        <span className='fs-5'> 🎯 Soft Components</span>
                                                    </div>

                                                    <InfraTable title="" data={filteredSoft} />
                                                </>
                                            )}

                                        </div>
                                    );
                                })}


                                {SchemeFormik?.values?.progress === "completed" && (<>
                                    {questionnaire?.length > 0 && (
                                        <div className="card shadow p-4 mt-4">
                                            <h3 className="fw-bold mb-4" style={{ color: "brown" }}>
                                                <AiOutlineFileDone size={35} />  Outcome
                                            </h3>




                                            {questionnaire?.map((q, qi) => (
                                                <div key={qi}>

                                                    {/* 1 */}
                                                    <p className="fw-bold">1. Approx Number of Students Benefitted</p>
                                                    <div className="row mb-3">
                                                        <div className="col">General: {q.q1_general}</div>
                                                        <div className="col">SC: {q?.q1_sc}</div>
                                                        <div className="col">ST: {q?.q1_st}</div>
                                                        <div className="col">BC: {q?.q1_bc}</div>
                                                        <div className="col fw-bold">Total: {q?.q1}</div>
                                                    </div>

                                                    {/* 2 */}
                                                    <p className="fw-bold">2. Facilities improved for students:</p>
                                                    <div className="row mb-3">
                                                        <div className="col">Classrooms: {q?.q2_classroom}</div>
                                                        <div className="col">Labs: {q?.q2_labs}</div>
                                                        <div className="col">Library: {q?.q2_library}</div>
                                                        <div className="col">Toilets: {q?.q2_toilets}</div>
                                                        <div className="col">ICT: {q?.q2_ict}</div>
                                                        <div className="col">Sports: {q?.q2_sports}</div>
                                                        <div className="col">Hostel: {q?.q2_hostel}</div>
                                                        <div className="col">Others: {q?.q2_others}</div>
                                                    </div>

                                                    {/* 3 */}
                                                    <div className="row align-items-start mb-2">
                                                        <div className="col-md-6 fw-bold">
                                                            3. Any new academic programmes or skill courses introduced due to improved infrastructure:
                                                        </div>
                                                        <div className="col-md-6 text-break">
                                                            {q?.q3}
                                                            {q?.q3 === "Yes" && <> – <strong>Details:</strong> {q?.q3_yes}</>}
                                                        </div>
                                                    </div>

                                                    {/* 4 */}
                                                    <div className="row align-items-start mb-2">
                                                        <div className="col-md-6 fw-bold">
                                                            4.Has student attendance or enrolment increased after RUSA interventions:
                                                        </div>
                                                        <div className="col-md-6 text-break">
                                                            {q?.q4}
                                                            {q?.q4 === "Increased" && <> – <strong>Details:</strong> {q.q4_increased}</>}
                                                        </div>
                                                    </div>

                                                    {/* 5 */}
                                                    <div className="row align-items-start mb-2">
                                                        <div className="col-md-6 fw-bold">
                                                            5. Briefly describe improvements in academic activities.:
                                                        </div>
                                                        <div className="col-md-6 text-break">
                                                            {q.q5}
                                                        </div>
                                                    </div>

                                                    {/* 6 */}
                                                    <div className="row align-items-start mb-2">
                                                        <div className="col-md-6 fw-bold">
                                                            6.NAAC Accreditation Status (Before and After RUSA support):
                                                        </div>
                                                        <div className="col-md-6 text-break">
                                                            Before {q.q6} &nbsp; After {q.q6_after}
                                                        </div>
                                                    </div>

                                                    {/* 7 */}
                                                    <div className="row align-items-start mb-2">
                                                        <div className="col-md-6 fw-bold">
                                                            7. Has the institution received new recognition, ranking, or awards post-RUSA :
                                                        </div>
                                                        <div className="col-md-6 text-break">
                                                            {q.q7}
                                                            {q.q7 === "Yes" && (<>
                                                                &emsp; <strong>Details:</strong> {q.q7_newrecognition}
                                                            </>)}
                                                        </div>
                                                    </div>

                                                    {/* 8 */}
                                                    <div className="row align-items-start mb-2">
                                                        <div className="col-md-6 fw-bold">
                                                            8. Facilities benefitting girl students / differently-abled students:
                                                        </div>
                                                        <div className="col-md-6 text-break">
                                                            {q.q8}
                                                        </div>
                                                    </div>

                                                    {/* 9 */}
                                                    <div className="row align-items-start mb-2">
                                                        <div className="col-md-6 fw-bold">
                                                            9. Major challenges faced in implementation:
                                                        </div>
                                                        <div className="col-md-6 text-break">
                                                            {q.q9}
                                                        </div>
                                                    </div>

                                                    {/* 10 */}
                                                    <div className="row align-items-start mb-2">
                                                        <div className="col-md-6 fw-bold">
                                                            10. Improvement in energy efficiency or sustainability practices (solar panels, green campus, etc.):
                                                        </div>
                                                        <div className="col-md-6 text-break">
                                                            {q.q10}
                                                        </div>
                                                    </div>

                                                    {/* 11 */}
                                                    <div className="row align-items-start mb-2">
                                                        <div className="col-md-6 fw-bold">
                                                            11. Suggestions for further improvement :
                                                        </div>
                                                        <div className="col-md-6 text-break">
                                                            {q.q11}
                                                        </div>
                                                    </div>

                                                </div>
                                            ))}


                                        </div>
                                    )}
                                </>)}
                            </div>
                        ) : (
                            Errormsg === false && noDataFound && (
                                <center className="text-danger h5 pt-5">
                                    ***** No Data Found *****
                                </center>
                            )
                        )}

                    </bie.Container>



                </Form >
            </FormikProvider >

        </>
    )
}
